import { createContext, useCallback, useContext, useMemo, useState } from "react";

const PanelContext = createContext(null);

export const PanelProvider = ({ children }) => {
  const [openPanelId, setOpenPanelId] = useState(null);

  const openPanel = useCallback((id) => setOpenPanelId(id), []);
  const closePanel = useCallback(() => setOpenPanelId(null), []);
  const togglePanel = useCallback((id) => setOpenPanelId((current) => (current === id ? null : id)), []);

  const value = useMemo(
    () => ({ openPanelId, openPanel, closePanel, togglePanel }),
    [openPanelId, openPanel, closePanel, togglePanel]
  );

  return <PanelContext.Provider value={value}>{children}</PanelContext.Provider>;
};

export const usePanelContext = () => {
  const context = useContext(PanelContext);
  if (!context) throw new Error("usePanelContext must be used within a PanelProvider");
  return context;
};
